import React, {Component} from 'react';
import {Container, Row, Col, Card, CardBody, CardFooter, Button, Input, InputGroup, FormText} from 'reactstrap';
import { TextMask, InputAdapter } from 'react-text-mask-hoc';
import {ajaxWrapperPost} from "../../../utils/deviceAPI";
import NotificationHOC from "../../../components/Notifications/NotificationHOC"
import { AnimatedDivSlide, AnimatedDivOpacity } from '../../../../src/animations/index';
import posed from 'react-pose';
let RegistrationInProgress = posed.div({
    visibleOpacityuserFormSubmitAction: {
        opacity:1,
        transition: {
            ease:[0.530, 0.035, 0.070, 1.290],
            duration: 500,
        }
    },
    hiddenOpacityuserFormSubmitAction: {
        opacity: 0,
        transition: {
            ease:[0.530, 0.035, 0.070, 1.290],
            duration: 500,
        }
    }
});

let RegistrationMessage = posed.div({
    visibleRegistrationMessage: {
        opacity:1,
        transition: {
            ease:[0.530, 0.035, 0.070, 1.290],
            duration: 500,
        }
    },
    hiddenRegistrationMessage: {
        opacity: 0,
        transition: {
            ease:[0.530, 0.035, 0.070, 1.290],
            duration: 500,
        }
    }
});

class PasswordResetConfirm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: props.match.params.email === "none" ? "" : props.match.params.email,
            userEmailValid: !(props.match.params.email === "none"),
            userEmailMessage: "",
            pageisDoneLoading:false,
            slideAnimationDone:false,
            registrationVisible:true,
            password:"",
            userPasswordValid: false,
            userPasswordMessage: "",
            passwordR:"",
            userPasswordRValid: false,
            userPasswordRMessage: "",
            userFormSubmitActionButtonText: "Change Password",
            userFormSubmitActionLoading:false,
            registrationMessageVisible:false,
            registrationMessage: "",
        };
        this.handleChange = this.handleChange.bind(this);
        this.forgotPassword = this.forgotPassword.bind(this);
        this.forgotPasswordAction = this.forgotPasswordAction.bind(this);
    }

    forgotPasswordAction() {
        this.setState({
            userFormSubmitAction: true,
            slideAnimationDone:false,
            userFormSubmitActionButtonText: "Please Wait..."
        })
    }

    forgotPassword() {
        let postData = {
            email: this.state.email,
            password: this.state.password,
            passwordR: this.state.passwordR,
            secret: this.props.match.params.secret
        };
        setTimeout(() => {
            ajaxWrapperPost(`/api/user/passwordResetChangePassword`,postData).then((data) => {
                console.log(data);
                if (data.error === false) {
                    this.setState({
                        registrationMessage: data.message
                    })
                }
                else if (data.error === true) {
                    this.refs.notification.notify(data.message,'error');
                    this.setState({
                        registrationMessage: data.message
                    })
                }
            });
        }, 3000);

    }

    handleChange({ target }) {
        const name = target.name;
        const value = target.value;
        this.setState({
                [name]: value
            },
            () => { this.validateField(name, value) }

        );
    }

    validateField(fieldName, value) {
        let _emailValid = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
        let _inviteUserEmailValid = this.state.userEmailValid;
        let _inviteUserEmailMessage = this.state.userEmailMessage;

        let _userPasswordValid = this.state.userPasswordValid;
        let _userPasswordMessage = this.state.userPasswordMessage;

        let _userPasswordRValid = this.state.userPasswordRValid;
        let _userPasswordRMessage = this.state.userPasswordRMessage;

        switch(fieldName) {
            case 'email':
                if (!_emailValid.test(value)) {
                    _inviteUserEmailValid = false;
                    _inviteUserEmailMessage = "Invalid Email";
                }
                else {
                    _inviteUserEmailValid = true;
                    _inviteUserEmailMessage = "";

                }
                break;
            case 'password':
                if (value.length < 8) {
                    _userPasswordValid = false;
                    _userPasswordRValid = false;
                    _userPasswordMessage = "Password must be 8 characters or greater !";
                }
                else if ((value.search(/[a-z]/i) < 0) || (value.search(/[0-9]/) < 0) || (value.search(/[A-Z]/i) < 0)) {
                    _userPasswordValid = false;
                    _userPasswordRValid = false;
                    _userPasswordMessage = "Password must contain at least one number, one uppercase character and one lowercase character!";
                }
                else {
                    _userPasswordValid = true;
                    _userPasswordMessage = "";
                    _userPasswordRValid = false;

                }
                break;
            case 'passwordR':
                if (value !== this.state.password) {
                    _userPasswordRValid = false;
                    _userPasswordRMessage = "Passwords do not match.";
                }
                else {
                    _userPasswordRValid = true;
                    _userPasswordRMessage = "";

                }
                break;
        }
        this.setState({
            userEmailValid:_inviteUserEmailValid,
            userEmailMessage:_inviteUserEmailMessage,
            userPasswordValid: _userPasswordValid,
            userPasswordMessage: _userPasswordMessage,
            userPasswordRValid: _userPasswordRValid,
            userPasswordRMessage: _userPasswordRMessage,
            userFormValid: _inviteUserEmailValid &&
                _userPasswordValid &&
                _userPasswordRValid

        });
    }
    componentDidMount() {
        this.setState(
            {
                pageisDoneLoading:true
            });
    }
    goToNewPage(path) {
        this.setState({slideAnimationDone:false},() => {
            setTimeout(() => {
                this.setState({pageisDoneLoading:false},() => {
                    setTimeout(() => {
                        this.props.history.replace(path);
                    },600)
                });
            }, 500);

        });
    }

    render() {
        return (
            <div className="app flex-row align-items-center" id="introBackground">
                <NotificationHOC ref="notification"/>
                <AnimatedDivSlide
                    pose={this.state.pageisDoneLoading ? 'visible' : 'hidden'}
                    className="login-container d-flex justify-content-center flex-column"
                    onPoseComplete={() => this.setState({slideAnimationDone: true})}
                >
                    <div className="flex-column px-lg-5 p-5 align-items-center" >
                        <AnimatedDivOpacity
                            pose={this.state.slideAnimationDone ? 'visibleOpacity' : 'hiddenOpacity'}
                            onPoseComplete={() => this.state.userFormSubmitAction && this.setState({registrationVisible:false,userFormSubmitActionLoading:true})}
                        >
                            { this.state.registrationVisible && <div className="col-12">
                                <Row>
                                    <div className="col-12">
                                        <CardBody className="card-body">
                                            <Row>
                                                <div className="col-12">
                                                    <h1>Confirm Password</h1>
                                                    <p className="text-muted">Please type your new password</p>
                                                </div>
                                            </Row>
                                            <InputGroup className="mb-3">
                                                <div className="input-group-prepend"><span className="input-group-text"><i className="fa fa-envelope-o"></i></span></div>
                                                <Input type="text" placeholder="Email" id="email" name="email" className={this.state.email.length === 0 ? "" : this.state.userEmailValid ? "is-valid" : "is-invalid"} value={ this.state.email } onChange={ this.handleChange } required readOnly={this.state.userFormSubmitAction}/>
                                                {this.state.userEmailMessage.length <= 0 ? "" :
                                                    <div className="invalid-feedback" id="passwordError" >{this.state.userEmailMessage}</div>
                                                }
                                            </InputGroup>
                                            <InputGroup className="mb-3">
                                                <div className="input-group-prepend"><span className="input-group-text"><i className="icon-lock"></i></span></div>
                                                <Input type="password" placeholder="Password" id="password" name="password" className={this.state.password.length === 0 ? "" : this.state.userPasswordValid ? "is-valid" : "is-invalid"} value={ this.state.password } onChange={ this.handleChange } required readOnly={this.state.userFormSubmitAction}/>
                                                {this.state.userPasswordMessage.length <= 0 ? "" :
                                                    <div className="invalid-feedback" id="passwordError" >{this.state.userPasswordMessage}</div>
                                                }
                                            </InputGroup>
                                            <InputGroup className="mb-4">
                                                <div className="input-group-prepend"><span className="input-group-text"><i className="icon-lock"></i></span></div>
                                                <Input type="password" placeholder="Repeat password" id="passwordR" name="passwordR" className={this.state.passwordR.length === 0 ? "" : this.state.userPasswordRValid ? "is-valid" : "is-invalid"} value={ this.state.passwordR } onChange={ this.handleChange } required readOnly={this.state.userFormSubmitAction}/>
                                                {this.state.userPasswordRMessage.length <= 0 ? "" :
                                                    <div className="invalid-feedback" id="passwordError" >{this.state.userPasswordRMessage}</div>
                                                }
                                            </InputGroup>
                                            <Row>
                                                <Col sm="12" className="mb-4">
                                                    <Button color="primary" className="px-4 btn btn-block" block disabled={!this.state.userFormValid && !this.state.userFormSubmitAction} onClick={() => {this.forgotPassword();this.forgotPasswordAction();}}>{this.state.userFormSubmitActionButtonText}</Button>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm="12">
                                                    <hr className="mb-4"/>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm="12">
                                                    <Col xs="12" >
                                                        Do you currently have an account? <button className="btn btn-link text-black-50" onClick={() => this.goToNewPage('/login')}>Go back to Login</button><br/>
                                                    </Col>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </div>
                                </Row>
                            </div>
                            }
                        </AnimatedDivOpacity>
                        <RegistrationInProgress
                            pose={this.state.userFormSubmitActionLoading ? 'visibleOpacityuserFormSubmitAction' : 'hiddenOpacityuserFormSubmitAction'}
                            onPoseComplete={() => {
                                if (this.state.userFormSubmitAction) this.setState({registrationVisible:false});
                                setTimeout(() => {
                                    this.setState({
                                        userFormSubmitActionLoading:false,
                                        registrationMessageVisible:true
                                    });
                                },3000);
                            }}
                        >
                            <div className="col-12">
                                <div className="sk-circle align-items-center">
                                    <div className="sk-circle1 sk-child"></div>
                                    <div className="sk-circle2 sk-child"></div>
                                    <div className="sk-circle3 sk-child"></div>
                                    <div className="sk-circle4 sk-child"></div>
                                    <div className="sk-circle5 sk-child"></div>
                                    <div className="sk-circle6 sk-child"></div>
                                    <div className="sk-circle7 sk-child"></div>
                                    <div className="sk-circle8 sk-child"></div>
                                    <div className="sk-circle9 sk-child"></div>
                                    <div className="sk-circle10 sk-child"></div>
                                    <div className="sk-circle11 sk-child"></div>
                                    <div className="sk-circle12 sk-child"></div>
                                </div>
                            </div>
                        </RegistrationInProgress>
                        <RegistrationMessage pose={this.state.registrationMessageVisible ? 'visibleRegistrationMessage' : 'hiddenRegistrationMessage'}>
                            <Row className="justify-content-center">
                                <Col md="12">
                                    <h1>Password Change</h1>
                                    <p className="text-muted">{this.state.registrationMessage}</p>
                                    <hr className="mb-4"/>
                                    <a href="#/login">
                                        <Button color="link" className="px-4 btn btn-block">Return to Login</Button>
                                    </a>
                                </Col>
                            </Row>
                        </RegistrationMessage>
                    </div>
                </AnimatedDivSlide>
            </div>
        );
    }
}

export default PasswordResetConfirm;



// WEBPACK FOOTER //
// ./src/views/Pages/PasswordReset/PasswordResetConfirm.js